import { render, staticRenderFns } from "./Template5.vue?vue&type=template&id=5bbd4ef6&scoped=true&"
import script from "./Template5.vue?vue&type=script&lang=js&"
export * from "./Template5.vue?vue&type=script&lang=js&"
import style0 from "./Template5.vue?vue&type=style&index=0&id=5bbd4ef6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbd4ef6",
  null
  
)

export default component.exports